import { Button, ButtonProps, SxProps, Typography } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { useId } from 'react';

interface Props extends ButtonProps {
  disabled?: boolean;
  text?: string;
  onClick?: () => void;
  id?: string;
}

const DefaultButton: React.FC<Props> = ({ disabled, text, onClick, sx, id, ...buttonProps }) => {

  const accessibility = useAccessibility();

  const autoId = useId();

  const sxStyle: SxProps = {
    borderRadius: '80px',
    padding: '12px 32px',
    minWidth: 'min-content',
    '@media (max-width: 799px)': {
      width: 'stretch',
    },
    border: disabled ? '2px solid #DBDBDB' : '2px solid #00995d',
  }

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      style={accessibility.buttonStyleAccessibility}
      variant='contained'
      sx={{ ...sxStyle, ...sx}}
      id={id || autoId}
      {...buttonProps}
    >
      {text ?
        <Typography style={accessibility.buttonTextStyleAccessibility}>{text}</Typography>
        :
        buttonProps.children
      }
    </Button>
  )
}

export default DefaultButton;